export var UserMasqPermission;
(function (UserMasqPermission) {
    UserMasqPermission["SuperUser"] = "superuser";
    UserMasqPermission["ReadOnly"] = "readonly";
    /**
     * Only `cio_integration` sends this level. `ui_api` reports a redacted
     * masquerade as `readonly`, or `superuser` for a super admin, so a client
     * that reads `ui_api` never sees this value. Do not build a client-side
     * redaction gate on it until `ui_api` reports it (FPS-3547).
     */
    UserMasqPermission["Redacted"] = "redacted";
    UserMasqPermission["ReadWrite"] = "readwrite";
    UserMasqPermission["MasqLevelNotSet"] = "none";
    UserMasqPermission["NoMasqAccess"] = "";
})(UserMasqPermission || (UserMasqPermission = {}));
export var MasqAccess;
(function (MasqAccess) {
    MasqAccess["ReadWrite"] = "readwrite";
    MasqAccess["Read"] = "read";
    MasqAccess["None"] = "none";
})(MasqAccess || (MasqAccess = {}));
export function masqAccess(permissions) {
    if ([UserMasqPermission.SuperUser, UserMasqPermission.ReadWrite].includes(permissions)) {
        return MasqAccess.ReadWrite;
    }
    else if ([UserMasqPermission.ReadOnly, UserMasqPermission.Redacted].includes(permissions)) {
        return MasqAccess.Read;
    }
    return MasqAccess.None;
}
//# sourceMappingURL=masq.js.map